import { render, staticRenderFns } from "./StatesList.vue?vue&type=template&id=c080f6ae&"
import script from "./StatesList.vue?vue&type=script&lang=js&"
export * from "./StatesList.vue?vue&type=script&lang=js&"
import style0 from "./StatesList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports